import React from 'react';
import { RMRectangle } from 'business/models/CustomModels';
import { Path } from 'react-konva';

export const CompositeRectsShape = ({ rectangles }: { rectangles: RMRectangle[] }) => {
  const pathData = rectangles
    .map(({ x, y, w, h }) => `M${x},${y}h${w}v${h}h-${w}Z`)
    .join(' ');

  return <Path id='compositerectshape-path' data={pathData} fill="#DBF0F9" opacity={0.8} />;
};
